export const iconFontAwesomeGamingChess = (
	<i className="fa-solid fa-chess"></i>
);
